<lx-form-field-selector
  [small]="small"
  [label]="label"
  [disabled]="disabled"
  [value]="value"
  valueExpr="code"
  [itemList]="itemList"
  [buttonView]="false"
  [placeholder]="placeholder"
  [required]="required"
  [searchEnabled]="false"
  [iconValidation]="true"
  (valueChange)="dirty = true; valueChange.emit($event)"
  (dropdownClosed)="dropdownClosed.emit()"
></lx-form-field-selector>
